import React from 'react';
import cn from 'classnames';
import styles from './Input.styles.scss';
import { InputTextarea } from 'primereact/inputtextarea';

const Input = ({
  className,
  fieldClassName,
  endAdornmentClassName,
  startAdornmentClassName,
  disabled,
  multiline,
  hasError,
  inputRef,
  startAdornment,
  endAdornment,
  value,
  maxlength,
  maxLength,
  minLength,
  showPercentageAdornment,
  onChange,
  ...restProps
}) => {
  const Component = multiline ? InputTextarea : 'input';

  const handleInputChange = (event) => {
    const input = event.target;
    let newValue = input.value;

    // Handle backspace when showPercentageAdornment is enabled
    if (showPercentageAdornment) {
      // Get cursor position before change
      const cursorPosition = input.selectionStart;

      // If value ends with % and user pressed backspace, remove the % from display but keep underlying value
      if (event.nativeEvent.inputType === 'deleteContentBackward') {
        // Remove the % from the displayed value
        newValue = newValue.slice(0, -1);

        // Adjust cursor position to be before where the % was
        if (cursorPosition === input.value.length) {
          input.selectionStart = cursorPosition - 1;
          input.selectionEnd = cursorPosition - 1;
        }
      }

      // If user tries to type %, ignore it since we're appending it
      if (newValue.endsWith('%')) {
        newValue = newValue.slice(0, -1);
      }
    }

    // Call the original onChange handler with the processed value
    if (onChange) {
      event.target.value = newValue; // Update the event target value before calling onChange
      onChange(event);
    }

    // Update the value state with the processed value
    // Note: We're not setting state here since this is a controlled component
    // The parent component should handle state updates
  };

  return (
    <div
      className={cn(
        styles.input,
        { [styles.inputDisabled]: disabled },
        className,
      )}
    >
      {startAdornment && (
        <div className={cn(styles.startAdornment, startAdornmentClassName)}>
          {startAdornment}
        </div>
      )}
      <Component
        {...restProps}
        ref={inputRef}
        maxLength={maxLength || maxlength}
        minLength={minLength}
        autoResize
        className={cn(
          'input-field',
          styles.field,
          {
            [styles.hasError]: hasError,
            [styles.multiline]: multiline,
            [styles.withStartAdorment]: !!startAdornment,
            [styles.withEndAdorment]: !!endAdornment,
          },
          fieldClassName,
        )}
        value={showPercentageAdornment && value ? `${value}%` : value || ''}
        disabled={disabled}
        onChange={handleInputChange}
      />
      {endAdornment && (
        <div className={cn(styles.endAdornment, endAdornmentClassName)}>
          {endAdornment}
        </div>
      )}
    </div>
  );
};

export default React.memo(Input);
